var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from "react";
import { IdenticonsCustomProperty, useColorMap } from "../common";
export var IdenticonCredentialUser = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(" + IdenticonsCustomProperty.light + ", " + colorMap.light + ")",
        base: "var(" + IdenticonsCustomProperty.base + ", " + colorMap.base + ")",
        dark: "var(" + IdenticonsCustomProperty.dark + ", " + colorMap.dark + ")",
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M6.003 8h35.934a4.003 4.003 0 014.004 4.003v23.994A4.003 4.003 0 0141.937 40H6.003A4.003 4.003 0 012 35.997V12.003A4.003 4.003 0 016.003 8z", fill: fills.light }),
        React.createElement("path", { d: "M12.981 20.987a3.014 3.014 0 116.028 0 3.014 3.014 0 01-6.028 0zM10.836 26.092a3.01 3.01 0 012.129-.883h6.045a3.01 3.01 0 012.129.883 3.01 3.01 0 01.883 2.13v.604c0 .664-.54 1.204-1.204 1.204h-9.652a1.21 1.21 0 01-1.21-1.21v-.597c0-.8.317-1.566.88-2.13z", fill: fills.dark }),
        React.createElement("path", { d: "M25.914 26.997a1.89 1.89 0 011.891-1.891h6.497a1.89 1.89 0 110 3.781h-6.497a1.894 1.894 0 01-1.89-1.89zM25.914 20.952a1.89 1.89 0 011.891-1.891h8.25a1.89 1.89 0 010 3.782h-8.25a1.892 1.892 0 01-1.89-1.891z", fill: fills.base })));
};
